import { VirtualListState } from '@epam/uui-core';
import { useState } from 'react';

export const useScroll = () => {
  const [value, setValue] = useState<VirtualListState>({
    topIndex: 0,
  });
  const [scrollValue, setActiveScrollValue] = useState<number>(0);

  const handleScroll = (ref: any) => {
    setTimeout(() => {
      const list = ref.current;
      const scrollPositionValue = list?.scrollTop;

      setActiveScrollValue(scrollPositionValue!);
    }, 100);
  };

  return { value, setValue, handleScroll, scrollValue };
};
